var map = {
	"./1.webp": 748,
	"./10.webp": 749,
	"./11.webp": 750,
	"./12.webp": 751,
	"./2.webp": 752,
	"./3.webp": 753,
	"./4.webp": 754,
	"./5.webp": 755,
	"./6.webp": 756,
	"./7.webp": 757,
	"./8.webp": 758,
	"./9.webp": 759,
	"./GG-Icon": 473,
	"./GG-Icon.png": 473,
	"./background": 760,
	"./background.png": 760,
	"./burger_menu": 474,
	"./burger_menu.png": 474,
	"./club.webp": 761,
	"./error-icon": 323,
	"./error-icon.svg": 323,
	"./log_out.webp": 762,
	"./player_profile.webp": 763,
	"./settings.webp": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1347;